/* istanbul ignore file */
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

export const TabsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow-x: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`;
export const ScrollArrow = styled.div`
  ${({ isDisplay }) => (isDisplay ? `display:block` : `display: none`)};
  ${({ direction }) =>
    direction === 'left' && `margin-left: auto; padding-right: 0.5rem;`};
  ${({ direction }) =>
    direction === 'right' && `margin-right: auto; padding-left: 0.5rem;`};

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

export const Tab = styled.div`
  box-sizing: border-box;
  padding: 1rem;
  font-size: 1.2rem;
  ${({ isSelected }) =>
    isSelected
      ? `
            font-weight: bold;
            background-color: ${getColor('zircon')};
            opacity: 1;
         `
      : `
            &:hover{cursor: pointer; opacity: 0.8;}
            opacity: 1;
        `}
  & > img {
    height: 1rem;
    width: 1rem;
    margin-right: 0.5rem;
  }
`;

export const ValueLine = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  & > svg {
    margin-left: 0.1rem;
  }
`;

export const TabsClipboards = styled.div`
  width: 100%;
  height: 13rem;
  & header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 20%;
    width: 100%;
    ${TabsWrapper} {
      overflow-x: scroll;
      ::-webkit-scrollbar {
        display: none;
      }
      & ${Tab} {
        box-sizing: border-box;
        padding: 1rem;
        min-width: fit-content;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
  }
  & main {
    height: 80%;
    padding: 1rem;
    background-color: ${getColor('zircon')};
    overflow-y: scroll;
    & ${ValueLine} {
      font-size: 1.1rem;
      width: fit-content;
      &:hover {
        background-color: ${getColor('catskillWhite')};
        cursor: pointer;
        font-weight: bold;
      }
    }
  }
`;
